/**
 * Типы и константы для EventType на frontend.
 *
 * Соответствуют backend EventTypeDto и доменным enum'ам:
 * ParticipantKind, OutcomeScheme, ScoringRuleType.
 */

// ===================================================================================================================
// = ParticipantKind
// ===================================================================================================================

export const ParticipantKind = Object.freeze({
  TEAM: 'TEAM',
  INDIVIDUAL: 'INDIVIDUAL',
});

export const PARTICIPANT_KIND_OPTIONS = Object.freeze([
  { value: ParticipantKind.TEAM, label: 'Команда / организация', hint: 'Команды, клубы, сборные' },
  { value: ParticipantKind.INDIVIDUAL, label: 'Один участник', hint: 'Отдельные спортсмены или игроки' },
]);

// ===================================================================================================================
// = OutcomeScheme
// ===================================================================================================================

export const OutcomeScheme = Object.freeze({
  SCORE_BASED: 'SCORE_BASED',
  WINNER_ONLY: 'WINNER_ONLY',
  WINNER_WITH_METHOD: 'WINNER_WITH_METHOD',
  PLACEMENT: 'PLACEMENT',
  INDIVIDUAL_SCORE: 'INDIVIDUAL_SCORE',
  CUSTOM: 'CUSTOM',
});

// ===================================================================================================================
// = ScoringRuleType
// ===================================================================================================================

export const ScoringRuleType = Object.freeze({
  // Legacy
  EXACT_MATCH: 'EXACT_MATCH',
  PARTIAL_MATCH: 'PARTIAL_MATCH',
  // Scoring v2
  EXACT_SCORE: 'EXACT_SCORE',
  SCORE_DIFFERENCE: 'SCORE_DIFFERENCE',
  CORRECT_WINNER: 'CORRECT_WINNER',
  CORRECT_METHOD: 'CORRECT_METHOD',
  EXACT_PLACEMENT: 'EXACT_PLACEMENT',
});

// ===================================================================================================================
// = Win methods defaults
// ===================================================================================================================

export const DEFAULT_WIN_METHODS = Object.freeze(['KO', 'SUB', 'DECISION']);

export const WIN_METHOD_LABELS = Object.freeze({
  KO: 'Нокаут (KO)',
  SUB: 'Сабмишн (SUB)',
  DECISION: 'Решение судей (DECISION)',
});

// ===================================================================================================================
// = EventType shape
// ===================================================================================================================

/**
 * Форма EventType для UI конструктора.
 */
export const EMPTY_EVENT_TYPE = Object.freeze({
  name: '',
  slug: '',
  description: '',
  participantKind: ParticipantKind.TEAM,
  participantCountMin: 2,
  participantCountMax: 2,
  participantLabel: '',
  outcomeScheme: OutcomeScheme.SCORE_BASED,
  scoreDrawPolicy: 'DRAW_ALLOWED',
  winMethods: [...DEFAULT_WIN_METHODS],
  individualScoreMin: 0,
  individualScoreMax: 100,
  individualScorePrecision: 1,
  applicableScoringRules: ['EXACT_SCORE', 'SCORE_DIFFERENCE', 'CORRECT_WINNER'],
  defaultScoringProfileId: null,
});
